













  import Component from 'vue-class-component';
  import { xComponentMixin } from '../../../components';
  import BaseEventButton from '../../../components/base-event-button.vue';
  import { VueCSSClasses } from '../../../utils';
  import { XEventsTypes } from '../../../wiring';
  import { facetsXModule } from '../x-module';
  import FacetsMixin from './facets.mixin';

  /**
   * Renders a simple button, emitting the needed events when clicked.
   *
   * @remarks It extends {@link FacetsMixin}.
   *
   * @public
   */
  @Component({
    components: { BaseEventButton },
    mixins: [xComponentMixin(facetsXModule)]
  })
  export default class ClearFilters extends FacetsMixin {
    /**
     * The events that will be emitted when the button clear filters is clicked.
     *
     * @returns The events to be emitted when the button clear filters is clicked.
     * @internal
     */
    protected get events(): Partial<XEventsTypes> {
      return this.facetsIds
        ? {
            UserClickedClearAllFilters: this.facetsIds
          }
        : {
            UserClickedClearAllFilters: undefined
          };
    }

    /**
     * Dynamic CSS classes to apply to the component.
     *
     * @returns The dynamic CSS classes to apply to the component.
     * @internal
     */
    protected get cssClasses(): VueCSSClasses {
      return {
        'x-clear-filters--has-not-selected-filters': !this.hasSelectedFilters,
        'x-clear-filters--has-selected-filters': this.hasSelectedFilters
      };
    }
  }
